import React, { useCallback, useEffect, useState } from 'react';

import { useConfig } from './../../hooks/use-config';
import PricingToggle from './components/toggle';
import CreditProducts from './credits_products';
import AddonProducts from './addon_products';
import CompareProducts from './compare_products';
import Credibility from './components/credibility';
import classnames from 'classnames'
import _ from 'lodash'

import * as PricingConstants from './helpers/constant';
import * as Constants from './../../helpers/constants';

import './scss/styles.scss';
import TestimonialsPricing from './pages-component/testimonials-pricing';
// import EfficientServices from './components/efficient_services'
import PricingSkeletonLoaderGroup from './components/pricing_card_loader';


const initialState = {
  selectedToggle: 'annual',
  isLoading: true,
  products: {},
  addons: [],
  payAsYouGoAddon: [],
  tabGroups: []
};

let controller = null;
let signal = null;

const PricingHome = () => {
  const { clearout: clearoutConfig } = useConfig();
  const [state, setState] = useState(initialState);

  const getProducts = useCallback(async () => {
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
    }));

    let url = clearoutConfig.api.baseurl + clearoutConfig.api.public_products;

    if (signal) controller.abort('cancelled');

    controller = new AbortController();
    signal = controller.signal;

    fetch(url, {
      method: 'GET',
      headers: {
        'Content-type': 'application/json; charset=UTF-8',
      },
      signal,
    })
      .then((response) => response.json())
      .then((res) => {
        if (res.status === Constants.CO_API.Success) {
          let tabGroups = res.data.tab_groups
          let products = res.data.products

          if (!_.isEmpty(tabGroups) && !_.isEmpty(products)) {
            let bfsTabGroup = _.find(tabGroups, { name: 'bfs_2025' })

            if (bfsTabGroup && !_.isEmpty(products.bfs_2025)) {
              setState((prevState) => ({
                ...prevState,
                selectedToggle: 'bfs_2025',
              }))
            }
          }

          setState((prevState) => ({
            ...prevState,
            tabGroups: res.data.tab_groups,
            products: res.data.products,
            addons: res.data.products.addons.products,
            payAsYouGoAddon: res.data.products.payg.products,
            isLoading: false,
          }));
        } else {
          setState((prevState) => ({
            ...prevState,
            tabGroups: {},
            products: {},
            addons: [],
            payAsYouGoAddon: [],
            isLoading: false,
          }));
        }
      })
      .catch((err) => {
        console.log('get plans erred', err);
        setState((prevState) => ({
          ...prevState,
          isLoading: false,
        }));
      });
  }, [clearoutConfig.api.baseurl, clearoutConfig.api.public_products]);

  useEffect(() => {
    getProducts();
  }, [getProducts]);

  const ontoggle = (option) => {
    setState((prevState) => ({
      ...prevState,
      selectedToggle: option,
      selectedSubscriptionType: option,
    }));
  };

  return (
    <>
      <section
        className={
          classnames('pricing-info-box mb-3', {
            bfs: _.includes(_.map(state.tabGroups, ({ name }) => name), 'bfs_2025') && state.selectedToggle === 'bfs_2025'
          })
        }
      >
        <PricingToggle
          tabGroups={state.tabGroups}
          ontoggle={ontoggle}
          selectedToggle={state.selectedToggle}
        />
      </section >
      {
        state.isLoading
          ? (
            <section className='pricing-info-box mt-4 mb-3'>
              <PricingSkeletonLoaderGroup isLoading={state.isLoading} />
            </section>
          )
          : (
            <>
              <section
                id='plans'
                className={
                  classnames('pricing-info-box mt-4 mb-3', {
                    bfs: _.includes(_.map(state.tabGroups, ({ name }) => name), 'bfs_2025') && state.selectedToggle === 'bfs_2025'
                  })
                }
              >
                <CreditProducts
                  selectedToggle={state.selectedToggle}
                  payAsYouGoAddon={state.payAsYouGoAddon}
                  products={state.products}
                  currency={PricingConstants.CURRENCY.USD.name}
                />
              </section>
            </>
          )
      }
      < section id='credibility' className='credibility-section mt-4 mb-3' >
        <Credibility />
      </section >

      <section id='testimonials' className='testimonials-section mt-4 mb-3'>
        <TestimonialsPricing />
      </section>
      {
        !state.isLoading && (
          <section id='addons' className='addon-section mt-4 mb-3'>
            <AddonProducts addons={state.addons} currency={PricingConstants.CURRENCY.USD.name} />
          </section>
        )
      }
      {
        !state.isLoading && (
          <section id='compare-plans' className='compare-product-section mt-4 mb-3'>
            <CompareProducts />
          </section>
        )
      }
    </>
  );
};

export default PricingHome;
